import React, { useContext, useState } from "react"
import { OtherLoginMethodsText, ForgotPasswordMsg } from "./loginStyles"
import {
  emailValidator,
  customerPasswordValidator,
  isValidResponse,
  ERROR_CODES,
} from "./inputValidators"
import { getLoginErrorMsg } from "./getErrorMsgString"
import OtherLoginMethods from "./otherLoginMethods"
import {
  HorizontalSpacer,
  Container,
  useForm,
} from "@omnichannel/ace-b2b-elements"
// import useLogin from "./helpers/useLogin"
import CommonRoundedButton from "./roundedButton"
import CommonInput from "./input"
import TogglePassword from "./togglePassword"
// import { toast } from "react-toastify"
// import UrlParamsContext from "../../context/UrlParamsContext"
import decodeUserToken from "./helpers/decodeUserToken"
import { navigate } from "gatsby"
// import { HOMEPAGE_WEB_BASE_URL, APP_ID } from "../../helpers/constants"
// import { mergeCart } from "../../helpers/cartMerger"


const FIELD_KEYS = Object.freeze({
  EMAIL: "email",
  PASSWORD: "password",
})

const EMAIL_VERIFIED_KEY = "VERIFIED"

const loginPasswordValidator = password => {
  const validationResult = customerPasswordValidator(password)

  if (validationResult.isValid) {
    return validationResult
  }

  switch (validationResult.error || null) {
    case ERROR_CODES.EMPTY_PASSWORD:
      return validationResult
    default:
      return isValidResponse
  }
}

export default props => {
  const [formDisabled, setFormDisabled] = useState(false)
  const [inputType, setInputType] = useState("password")
  const [toggleLabel, setToggleLabel] = useState("SHOW")
  const {
    setFormFieldValue,
    validateForm,
    getFormFieldValue,
    getFormFieldError,
  } = useForm({
    [FIELD_KEYS.EMAIL]: {
      validator: emailValidator,
    },
    [FIELD_KEYS.PASSWORD]: {
      validator: loginPasswordValidator,
    },
  })
  // const { login, isLoggingIn } = useLogin()
  const isLoggingIn = false
  const urlParams = ''//useContext(UrlParamsContext)

  const onChangeEmail = event =>
    setFormFieldValue(FIELD_KEYS.EMAIL, event.target.value)

  const onChangePassword = event =>
    setFormFieldValue(FIELD_KEYS.PASSWORD, event.target.value)


  const onKeyPress = event => {
    if (event.keyCode === 13) {
      onLogin();
      event.stopPropagation();
    }
  }

  const emailInputError = getLoginErrorMsg(getFormFieldError(FIELD_KEYS.EMAIL))
  const passwordInputError = getLoginErrorMsg(
    getFormFieldError(FIELD_KEYS.PASSWORD)
  )

  const emailInputValue = getFormFieldValue(FIELD_KEYS.EMAIL)
  const passwordInputValue = getFormFieldValue(FIELD_KEYS.PASSWORD)
  const loginButtonDisabled =
    !Boolean(
      emailInputValue &&
      emailInputValue.trim() &&
      passwordInputValue &&
      passwordInputValue.trim()
    ) || formDisabled

  const formFieldsDisabled = false   //formDisabled || isLoggingIn

  const appId = ''//urlParams?.appId || APP_ID

  // const onLogin = async () => {
  //   const isFormValid = validateForm()
  //   const redirectUrl = (urlParams && urlParams.redirectUrl && decodeURIComponent(urlParams.redirectUrl)) || HOMEPAGE_WEB_BASE_URL

  //   if (isFormValid) {
  //     if (props.onLoginStarted) {
  //       props.onLoginStarted()
  //     }

  //     const response = await login({
  //       email: emailInputValue.toLowerCase(),
  //       password: passwordInputValue,
  //       ...(urlParams && urlParams.redirectUrl
  //         ? { redirectUrl: urlParams.redirectUrl }
  //         : {}),
  //       appId,
  //     })

  //     if (props.onLoginFinished) {
  //       props.onLoginFinished()
  //     }

  //     if (response && response.error) {
  //       // toast.error(response.error)
  //       return
  //     }

  //     if (response.verified === false) {
  //       // toast.info("Your account is not yet verified.")
  //       navigate("/verify-account", {
  //         state: {
  //           email: emailInputValue.trim(),
  //         },
  //       })
  //       return
  //     }

  //     const userData = decodeUserToken(response.accessToken)

  //     if (!userData) {
  //       // toast.error(
  //       //   "The Email address or password you entered is incorrect. Please try again"
  //       // )
  //       return
  //     }

  //     if (
  //       userData &&
  //       !(userData.emailStatus && userData.emailStatus === EMAIL_VERIFIED_KEY)
  //     ) {
  //       if (userData.email) {
  //         // toast.info("Your account is not yet verified.")
  //         navigate(`/verify-account?appId=${appId}`, {
  //           state: {
  //             email: userData.email,
  //           },
  //         })
  //       }

  //       return
  //     }

  //     if (redirectUrl && redirectUrl.startsWith("SHOP_SM_MOBILE_APP")) {
  //       window.location.replace(
  //         `?redirectUrl=${redirectUrl}&accessToken=${response.accessToken}&refreshToken=${response.refreshToken}`
  //       )
  //       return
  //     }

  //     // localStorage.setItem("access-token", response.accessToken)
  //     // mergeCart().then(mergeResult => {
  //     //   const { statusCode, success, errorMessage } = mergeResult.data.mergeFromDevice
  //     //   console.info("merge::", statusCode, success, errorMessage)
  //     //   window.location = redirectUrl
  //     // }).catch(error => {
  //     //   console.error("merge error::", error)
  //     // })
  //     navigate(`/?redirectUrl=${encodeURIComponent(redirectUrl)}&accessToken=${response.accessToken}&refreshToken=${response.refreshToken}`)
  //   }
  // }

  const toggleShowHide = () => {
    inputType === 'password' ? setInputType("text") : setInputType("password")
    toggleLabel === 'SHOW' ? setToggleLabel("HIDE") : setToggleLabel("SHOW")
  }

  return (
    <Container hidden={!props.selected} width={"100%"}>
      <HorizontalSpacer />
      <CommonInput
        disabled={formFieldsDisabled}
        label="Email Address"
        placeholder="ex. sam@gmail.com"
        type="email"
        error={emailInputError}
        onChange={onChangeEmail}
        onKeyDown={onKeyPress}
      />
      <HorizontalSpacer height={"1.2rem"} />
      <TogglePassword
        label={"Password"}
        onClick={toggleShowHide}
        formFieldsDisabled={formFieldsDisabled}
        inputType={inputType}
        error={passwordInputError}
        onChange={onChangePassword}
        toggleLabel={toggleLabel}
        onKeyDown={onKeyPress}
      />
      <HorizontalSpacer />
      <ForgotPasswordMsg
        onClick={() => !formFieldsDisabled && navigate(`/forgot-password?appId=${appId}`)}
      >
        Forgot your password?
      </ForgotPasswordMsg>
      <HorizontalSpacer height={"2rem"} />
      <div style={{ width: '100%', padding: "0 5rem", margin: "0 0 0 .2rem" }}>
        <CommonRoundedButton
          disabled={loginButtonDisabled || formFieldsDisabled}
          primary
        // onClick={() => onLogin()}
        >
          {isLoggingIn ? "Logging in..." : "Login"}
        </CommonRoundedButton>
      </div>
      {/* <Container textAlign="center" margin="2.4rem 0 2.4rem 0">
        <OtherLoginMethodsText>Or</OtherLoginMethodsText>
      </Container> */}
      {/* <OtherLoginMethods
        disabled={isLoggingIn}
        redirectUrl={props.redirectUrl}
        onFacebookLogin={() => {
          props.onFacebookLogin()
          setFormDisabled(true)
        }}
        onGoogleLogin={() => {
          props.onAppleLogin()
          setFormDisabled(true)
        }}
        onAppleLogin={() => {
          props.onAppleLogin()
          setFormDisabled(true)
        }}
      /> */}
    </Container>
  )
}
